<template>
  <div>
    <Spinner v-if="isLoading" />

    <div class="notification is-info" v-if="hasNoMembers">No members found.</div>

    <div class="notification is-danger" v-if="loadError">{{ loadError }}</div>

    <button class="button is-success is-fullwidth is-outlined add-member"
      v-if="!isLoading"
      @click="addMember()"
      >Add Member</button>

    <HuntAreaMembersList
      :huntArea="huntArea"
      :members="members"
      v-if="membersLoaded"
      @remove-member="removeMember($event)"/>

    <HuntAreaRemoveMemberModal
      v-if="memberToRemove != null"
      :huntAreaStorePath="huntAreaStorePath"
      :huntArea="huntArea"
      :member="memberToRemove"
      @cancelled="closeRemoveMemberModal"
      @succeeded="closeRemoveMemberModal"
    />

    <HuntAreaAddMemberModal
      v-if="showAddMemberModal"
      :huntAreaStorePath="huntAreaStorePath"
      @cancelled="closeAddMemberModal"
      @succeeded="closeAddMemberModal"
    />
  </div>
</template>

<script>
import Spinner from "@/components/utils/Spinner";
import HuntAreaMembersList from "./HuntAreaMembersList";
import HuntAreaRemoveMemberModal from "./HuntAreaRemoveMemberModal";
import HuntAreaAddMemberModal from "./HuntAreaAddMemberModal";

import {
  GET_HUNT_AREA,
  LOAD_MEMBERS,
  GET_MEMBERS,
  IS_LOADING_MEMBERS,
  GET_MEMBERS_LOAD_ERROR,
  HAS_EMPTY_MEMBERS_LOAD_RESULT
} from "./huntAreaStore";

export default {
  name: "HuntAreaMembersTab",

  components: {
    Spinner,
    HuntAreaMembersList,
    HuntAreaRemoveMemberModal,
    HuntAreaAddMemberModal
  },

  props: {
    huntAreaStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      memberToRemove: null,
      showAddMemberModal: false
    };
  },

  mounted() {
    const loadMembersAction = `${this.huntAreaStorePath}/${LOAD_MEMBERS}`;
    this.$store.dispatch(loadMembersAction);
  },

  methods: {
    removeMember(member) {
      this.memberToRemove = member;
    },

    closeRemoveMemberModal() {
      this.memberToRemove = null;
    },

    addMember() {
      this.showAddMemberModal = true;
    },

    closeAddMemberModal() {
      this.showAddMemberModal = false;
    }
  },

  computed: {
    membersLoaded() {
      return this.huntArea != null && this.members !== null;
    },

    huntArea() {
      const getHuntArea = `${this.huntAreaStorePath}/${GET_HUNT_AREA}`;
      return this.$store.getters[getHuntArea];
    },

    members() {
      const getMembers = `${this.huntAreaStorePath}/${GET_MEMBERS}`;
      return this.$store.getters[getMembers];
    },

    isLoading() {
      const isLoadingMembers = `${this.huntAreaStorePath}/${IS_LOADING_MEMBERS}`;
      return this.$store.getters[isLoadingMembers];
    },

    hasNoMembers() {
      const hasEmptyMembersLoadResult = `${this.huntAreaStorePath}/${HAS_EMPTY_MEMBERS_LOAD_RESULT}`;
      return this.$store.getters[hasEmptyMembersLoadResult];
    },

    loadError() {
      const getMembersLoadError = `${this.huntAreaStorePath}/${GET_MEMBERS_LOAD_ERROR}`;
      return this.$store.getters[getMembersLoadError];
    }
  },

  watch: {
    huntArea() {
      this.showAddMemberModal = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.button.add-member {
  margin-bottom: 1em;
}
</style>
